import DataInfoCard, { DataInfoCardVariant } from "@/components/DataInfoCard";
import { dataInfoCardCss } from "../../OverviewDataResults.style";
import { ReadingGradeLevelCardProps } from "../../OverviewDataResults.type";

const ReadingGradeLevelCard = (props: ReadingGradeLevelCardProps) => {
  const { children, error, loading } = props;

  return error || loading ? (
    <DataInfoCard
      variant={DataInfoCardVariant.icon}
      statusText="... loading status"
      textContent="... loading grade level status based on average reading levels of texts viewed"
      error={error}
      loading={loading}
      additionalStyles={{ containerCss: dataInfoCardCss() }}
    />
  ) : (
    <>{children}</>
  );
};

export default ReadingGradeLevelCard;
